import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useChapterActionIdMatch from "../../../../hooks/useChapterActionIdMatch";

import SearchBlockRHF from "../../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import TableComponent from "../../../../components/GeneralComponents/SearchTable/tableComponent";
import ToolBlockKnowledgeTest from "../../../../components/knowledgeTestComponents/commonComponents/ToolBlockKnowledgeTest/ToolBlockKnowledgeTest";
import ModalWindowShowProtocolHistory from "../../../../components/knowledgeTestComponents/knoweledgeTestRecordComponents/ModalWindowShowProtocolHistory/ModalWindowShowProtocolHistory";
import NotificationWindow from "../../../../components/GeneralComponents/NotificationWindow/NotificationWindow";

import {
  options,
  setOptionsSections,
  setOptionsProgramId,
} from "../../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import { getDataKnoweledgeTestRecordBySearchParams } from "../../../../redux/knowledgeTestRecordReducer/actionsKnoweledgeTestRecord";

import {
  MODAL_WINDOW_HISTORY_PROTOCOLS_COLUMNS,
  SEARCH_KNOWELEDGE_TEST_RECORD_COLUMNS,
} from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

import { inputsForModalWindowProtocolHistory } from "./optionsForModalWindowProtocolHistory";

import styles from "./searchKnowledgeTestRecord.module.css";

function SearchKnowledgeTestRecord() {
  const dispatch = useDispatch();

  const [showModalWindow, setShowModalWindow] = useState(false);
  const [showNotificationWindow, setShowNotificationWindow] = useState(false);
  const [messageNotificationWindow, setMessageNotificationWindow] = useState("");
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [searchParams, setSearchParams] = useState({
    surname: "",
    name: "",
    midname: "",
    birthDate: "",
    section: 0,
    programId: 0,
    e1PassName: 0,
    e2PassName: 0,
    checkPassName: 0,
    protNum: "",
    protDate: "",
  });

  const knowledgeTestRecordState = useSelector((state) => {
    const { knowledgeTestRecordReducer } = state;
    return knowledgeTestRecordReducer;
  });
  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const addAccess = useChapterActionIdMatch(
    sortedMenuNames?.TRAINING_CHECK?.createAProtocol?.chapterActionId,
  );
  const viewAccess = useChapterActionIdMatch(
    sortedMenuNames?.TRAINING_CHECK?.viewTheProtocol?.chapterActionId,
  );
  const editAccess = useChapterActionIdMatch(
    sortedMenuNames?.TRAINING_CHECK?.editingAProtocol?.chapterActionId,
  );
  const additionalAccess = {
    printAccess: useChapterActionIdMatch(
      sortedMenuNames?.TRAINING_CHECK?.printingTheProtocol?.chapterActionId,
    ),
  };

  const handlerShowNotificationWindow = (responseData) => {
    setMessageNotificationWindow(responseData);
    setShowNotificationWindow(!showNotificationWindow);
  };

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };

  const handleSearch = () => {
    dispatch(getDataKnoweledgeTestRecordBySearchParams(searchParams, 0));
    setSelectedPage(0);
    setSelectedRowData(null);
  };

  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchParams(
      structuredClone({
        surname: "",
        name: "",
        midname: "",
        birthDate: "",
        section: 0,
        programId: 0,
        e1PassName: 0,
        e2PassName: 0,
        checkPassName: 0,
        protNum: "",
        protDate: "",
      }),
    );
    dispatch(
      getDataKnoweledgeTestRecordBySearchParams(
        {
          surname: "",
          name: "",
          midname: "",
          birthDate: "",
          section: 0,
          programId: 0,
          e1PassName: 0,
          e2PassName: 0,
          checkPassName: 0,
          protNum: "",
          protDate: "",
        },
        0,
      ),
    );
  };

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
  };

  useMemo(() => {
    setSelectedRowData(null);
    dispatch(getDataKnoweledgeTestRecordBySearchParams(searchParams, selectedPage));
  }, [selectedPage]);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(dictionaryReducer.gimsSections, options.inputsSearchKnoweledgeTestRecord.key);
    }
    if (dictionaryReducer.trainingProgramLibrary.length > 0) {
      const validLib = dictionaryReducer.trainingProgramLibrary.map((item) => {
        return {
          value: item.id,
          label: item.sign,
          key: "programId",
        };
      });
      setOptionsProgramId(validLib, options.inputsSearchKnoweledgeTestRecord.key, "programId");
    }
  }, [dictionaryReducer]);

  useEffect(() => {
    fetchPageData(0);
  }, []);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsSearchKnoweledgeTestRecord}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlockKnowledgeTest
        id={selectedRowData?.id}
        showModal={setShowModalWindow}
        addAccess={addAccess}
        additionalAccess={additionalAccess}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={SEARCH_KNOWELEDGE_TEST_RECORD_COLUMNS}
        data={knowledgeTestRecordState.dataForSearchTable.content || []}
        totalPages={knowledgeTestRecordState.dataForSearchTable.totalPages || 0}
        totalElements={knowledgeTestRecordState.dataForSearchTable.totalElements || 0}
        selectedPage={selectedPage}
      />
      {showModalWindow && (
        <ModalWindowShowProtocolHistory
          handlerShowNotificationWindow={handlerShowNotificationWindow}
          editAccess={editAccess}
          viewAccess={viewAccess}
          additionalAccess={additionalAccess}
          show={showModalWindow}
          setShowWindow={setShowModalWindow}
          modalTitle={"История протоколов"}
          inputs={inputsForModalWindowProtocolHistory}
          headersTable={MODAL_WINDOW_HISTORY_PROTOCOLS_COLUMNS}
          id={selectedRowData?.id}
        />
      )}
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        setShow={setShowNotificationWindow}
        headerText={"Уведомление"}
        messageText={messageNotificationWindow}
      />
    </div>
  );
}

export default SearchKnowledgeTestRecord;
